// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".partner-eth-address[data-v-7a105257]{cursor:copy}", ""]);
// Exports
module.exports = exports;
